import React from 'react'

// Creating the context object and passing the default values.
const SideBarContext = React.createContext()

export default SideBarContext
